import { render, staticRenderFns } from "./ColunaComCategoriasMapeadas.vue?vue&type=template&id=4ec49fbc&scoped=true"
import script from "./ColunaComCategoriasMapeadas.vue?vue&type=script&lang=js"
export * from "./ColunaComCategoriasMapeadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec49fbc",
  null
  
)

export default component.exports